import { render, staticRenderFns } from "./uploadButton.vue?vue&type=template&id=61f5a092&scoped=true&"
import script from "./uploadButton.vue?vue&type=script&lang=js&"
export * from "./uploadButton.vue?vue&type=script&lang=js&"
import style0 from "./uploadButton.vue?vue&type=style&index=0&id=61f5a092&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f5a092",
  null
  
)

export default component.exports